import { createContext } from 'react';
import { SpeciesData, StatsTable } from './helper/dex-species';

type ContextType = {
  dex: { [speciesId: string]: SpeciesData },
  GenusFlavorText: { [key: string]: { ftext: string, genus: string } },
  totalBaseSpecies: number,
  totalFilteredSpecies: number,
  filteredSpeciesIds: string[],
  megasAllowed: boolean,
  setMegasAllowed: (param: boolean) => void,
  gmaxAllowed: boolean,
  setGmaxAllowed: (param: boolean) => void,
  regionalsAllowed: boolean,
  setRegionalsAllowed : (param: boolean) => void,
  baseSpeciesAllowed: boolean,
  setBaseSpeciesAllowed: (param: boolean) => void,
  clickedSpeciesId: string,
  setClickedSpeciesId: (param: any) => void,
  gensAllowed: { [key:string]: boolean },
  handleSetGensAllowed: (param: any) => void,
  handleSetAllGenerations: (param: boolean) => void,
  baseFormesAllowed: boolean,
  setBaseFormesAllowed: (param: boolean) => void,
  typesSelected: string[],
  handleSetTypesSelected: (param: string) => void,
  averageStatsAllSpecies: StatsTable,
  spritePosition: { [key: string]: number[] },
  hpRange: number[],
  debouncedSetHpRange: (param: number[]) => void,
  attackRange: number[],
  debouncedSetAttackRange: (param: number[]) => void,
  defenseRange: number[],
  debouncedSetDefenseRange: (param: number[]) => void,
  specialAttackRange: number[],
  debouncedSetSpecialAttackRange: (param: number[]) => void,
  specialDefenseRange: number[],
  debouncedSetSpecialDefenseRange: (param: number[]) => void,
  speedRange: number[],
  debouncedSetSpeedRange: (param: number[]) => void,
  legendariesOnly: boolean,
  setLegendariesOnly: (param: boolean) => void,
  mythicalsOnly: boolean,
  setMythicalsOnly: (param: boolean) => void,
  fullyEvolvedOnly: boolean,
  setFullyEvolvedOnly: (param: boolean) => void,
  babyPokemonOnly: boolean,
  setBabyPokemonOnly: (param: boolean) => void,
  paradoxPokemonOnly: boolean,
  setParadoxPokemonOnly: (param: boolean) => void,
  ultraBeastsOnly: boolean,
  setUltraBeastsOnly: (param: boolean) => void,
};

const AppContext = createContext<ContextType>({
  gensAllowed: {},
} as ContextType);
export default AppContext;
